import React from "react";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
} from "../../components/Component";

// Common help topics shown on the public Help page. Kept as plain data so
// the content is easy to edit without touching the markup below.
const FAQS: { q: string; a: React.ReactNode }[] = [
  {
    q: "How do I sign in to ProcureX?",
    a: "Enter the email address and password provided by your organization on the Sign-In screen, then click “Sign in”. Use the eye icon in the password field to check what you have typed.",
  },
  {
    q: "I forgot my password. How do I reset it?",
    a: "On the login page, click “Forgot Password? Click here to reset”. Enter your registered email address and follow the reset link sent to your inbox.",
  },
  {
    q: "My account is locked or I cannot log in.",
    a: (
      <>
        Repeated incorrect attempts can temporarily lock your account. Wait a
        few minutes and try again, or contact your administrator. If the problem
        continues, reach us at{" "}
        <a href="mailto:info@procurextech.com">info@procurextech.com</a>.
      </>
    ),
  },
  {
    q: "Which browsers are supported?",
    a: "ProcureX works best on the latest versions of Google Chrome, Microsoft Edge, and Mozilla Firefox. Please keep your browser up to date for the best experience.",
  },
  {
    q: "How do I get access to a specific module?",
    a: "Module access is controlled by your organization's administrator based on your role. If you need access to a module you cannot see, please raise the request with your administrator.",
  },
  {
    q: "Who do I contact for further support?",
    a: (
      <>
        Our support team is happy to help. Email{" "}
        <a href="mailto:info@procurextech.com">info@procurextech.com</a> with a
        description of the issue and, if possible, a screenshot.
      </>
    ),
  },
];

// Public Help / FAQ page. Opened in a new tab from the login footer
// (AuthFooter), so it renders standalone without the app header.
const Help: React.FC = () => {
  return (
    <React.Fragment>
      <Head title="Help &amp; Support" />
      <div className="nk-content">
        <div className="container wide-lg py-4">
          <div className="content-page">
            <BlockHead size="lg">
              <BlockHeadContent>
                <BlockTitle tag="h2" className="fw-normal">
                  Help &amp; Support
                </BlockTitle>
                <BlockDes>
                  <p className="lead">
                    Answers to the questions we hear most often. If you cannot
                    find what you are looking for, our support team is only an
                    email away.
                  </p>
                </BlockDes>
              </BlockHeadContent>
            </BlockHead>
            <Block>
              <PreviewCard className="card-bordered" bodyClass="card-inner-xl">
                <div className="entry">
                  {FAQS.map((item, index) => (
                    <div className="mb-4" key={index}>
                      <h5>{item.q}</h5>
                      <p className="text-soft">{item.a}</p>
                    </div>
                  ))}
                  <hr />
                  <p>
                    <strong>Still need help?</strong> Contact us at{" "}
                    <a href="mailto:info@procurextech.com">
                      info@procurextech.com
                    </a>
                    .
                  </p>
                </div>
              </PreviewCard>
            </Block>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Help;
